import React from "react";
import "./styles/tailwind.css";
// import './styles/css/main.css';
import "./styles/scss/globals.scss";
import App from "./app/App";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/es";
import { createBrowserHistory } from "history";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://64a9afd53ccabf6b91d4921e1929f1e4@o379474.ingest.us.sentry.io/4510173035233280",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
});

dayjs.extend(relativeTime);
dayjs.locale("es");
createBrowserHistory();

const container = document.getElementById("root") as Element;
const root = createRoot(container); // createRoot is the new API in React 18
root.render(<App />);
